const includeRecaptchaJs = (recaptchaSiteKeyScore) => new Promise((resolve, reject) => {

	if (window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render) {

		resolve();
		return;

	}

	const script = document.createElement('script');
	const onloadCallbackName = 'onRecaptchaLoad';
	const render = recaptchaSiteKeyScore || 'render';

	window[onloadCallbackName] = resolve;

	script.onerror = (e) => {

		console.warn('reCAPTCHA Enterprise API JS library failed to load.');
		reject(e);

	};
	script.src = `https://www.google.com/recaptcha/enterprise.js?render=${render}&onload=${onloadCallbackName}`;

	document.head.appendChild(script);

});

export default includeRecaptchaJs;
